import { useCallback, useState } from "react";

import {
  INITIAL_DEFAULTS_CHOICE,
  armedDefaultsBrandId,
  defaultsChoiceFromUser,
  type DefaultsChoice,
} from "../armedDefaultsBrand";
import type { BrandId } from "../services/ai/brandRegistry";

/**
 * Defaults for this task-pane page load.
 *
 * A resolved brand arms Defaults unless the user has turned it off. Closing
 * the pane loads the page again and mounts a new hook from the initial choice.
 */
export function useArmedDefaultsBrand(resolvedBrandId: BrandId | null): {
  brandId: BrandId | null;
  setBrandId: (brandId: BrandId | null) => void;
} {
  const [choice, setChoice] = useState<DefaultsChoice>(INITIAL_DEFAULTS_CHOICE);

  const setBrandId = useCallback((brandId: BrandId | null) => {
    setChoice(defaultsChoiceFromUser(brandId));
  }, []);

  return {
    brandId: armedDefaultsBrandId({
      resolvedBrandId,
      optedOut: choice.optedOut,
      chosenBrandId: choice.chosenBrandId,
    }),
    setBrandId,
  };
}
